module.exports = __webpack_public_path__ + "img/paymentGuide.319dfd84.png";